
import { computed, defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'CertificatesItem',
  props: {
    skus: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const countLength = computed(() => {
      if (props.skus.length < 6) {
        return props.skus.length;
      }
      return 5;
    });

    return { countLength };
  },
});
